import React, { useState } from "react";

function BugReportModal({ isOpen, onClose }) {
  const [description, setDescription] = useState("");
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/submit-bug`, // updated to use env variable
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, description })
        }
      );
      if (!response.ok) {
        const data = await response.json();
        setError(data.error || "Failed to submit bug report.");
      } else {
        setSubmitted(true);
      }
    } catch (err) {
      setError("Network error. Please try again later.");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" style={{color:"black", position: 'fixed', top:0, left:0, width:'100vw', height:'100vh', background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000}}>
      <div className="modal-content" style={{ padding:'2rem', borderRadius:'8px', minWidth:'300px', maxWidth:'90vw'}}>
        <button onClick={onClose} style={{float:'right', fontSize:'1.2rem', border:'none', background:'none', cursor:'pointer'}}>×</button>
        <h2>Report a Bug</h2>
        {submitted ? (
          <p>Thank you for your report!</p>
        ) : (
          <form onSubmit={handleSubmit}>
            <div style={{marginBottom:'1rem'}}>
              <label>Description:</label><br />
              <textarea required value={description} onChange={e => setDescription(e.target.value)} rows={4} style={{width:'100%'}} />
            </div>
            <div style={{marginBottom:'1rem'}}>
              <label>Email (optional):</label><br />
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} style={{width:'100%'}} />
            </div>
            {error && <div style={{color:'red', marginBottom:'1rem'}}>{error}</div>}
            <button type="submit">Submit</button>
          </form>
        )}
      </div>
    </div>
  );
}

export default BugReportModal;
